import { useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { userPreferenceAPI } from '@atlassian/jira-user-preferences-services/src/utils/index.tsx';
import { STORE_KEY } from '../common/constants.tsx';

type Payload = {
	hasUserOptedOut: boolean;
	/* Controls the display of the "New" tag in GIC */
	hasUserDismissedReadMore: boolean;
	/* Controls the onboarding message displayed in GIC */
	hasUserDismissedGicOnboarding?: boolean; // TODO: Remove optional when cleaning up smart_fields_gic_toggle_fg
};

export const useSmartFieldsUpdateUserPreference = () => {
	const updatePreferences = useCallback(async (payload: Payload) => {
		try {
			await userPreferenceAPI.set<Payload>(STORE_KEY, payload);
		} catch (err) {
			fireErrorAnalytics({
				error: err instanceof Error ? err : new Error('Unknown error'),
				meta: {
					id: 'updateCommandPaletteOptInStatus',
					packageName: 'jiraPersonalSettingsGicSmartFields',
					teamName: 'gryffindor',
				},
			});
			throw err;
		}
	}, []);

	return { updatePreferences };
};
